import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../AuthContext";
import { FaMoneyBillWave, FaUserFriends,FaMoneyBill,FaSchool} from 'react-icons/fa';
import BarChart from '../components/BarChart'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from '../axios'
import PieChart from '../components/PieChart'
ChartJS.register(ArcElement, Tooltip, Legend);


function Dashboard() {
  const [students, setStudents] = useState("");
  const [expenses, setExpenses] = useState("");
  const [stores, setStores] = useState([]);
  const [products, setProducts] = useState([]);
  const[centreY,setCentre]=useState('')

  // Update Chart Data

  const authContext = useContext(AuthContext);
  const date=new Date()
  const year=date.getFullYear()
  // Fetching centres by year
const [overallTotals, setOverallTotals] = useState({});
const [centerDetails, setCenterDetails] = useState([]);
const[balance,setBalance]=useState('')
const[totBatch,setTotBatches]=useState('')
const[totStuds,setTotStuds]=useState('')
const[passed,setPassed]=useState('')
const[assessed,setAssessed]=useState('')
const[placed,setPlaced]=useState('')
const [fail,setFail]=useState('')
const[courseDetails,setCourseDetails]=useState([])
const fetchBatchData = async () => {
  try {
    const response = await axios.post(`batch/countAllBatchesCentrewise`,{
      centre_id:authContext.centre
    });
    const data = response.data;
    //console.log('batch data',data)
    setTotStuds(data.Total_Students_All_Batches)
    setTotBatches(data.Total_Batches)
    setExpenses(data.Total_Expenses)
    setBalance(data.Total_Balance)
    setCourseDetails(data.CourseDetails)
    // You can now use this data in your component's state or wherever needed

  } catch (error) {
    console.error('Error fetching data:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
  }
}  
useEffect(() => {
  if (authContext.userType === 'Admin') {
      fetchBatchData();
      axios.post('/students/getPassedPlacedAssessedForCentre',{
        centre_id:authContext.centre
      })
      .then(response => {
        const data = response.data;
        //console.log(data)
        setPassed(data.Tot_Passed_Student)
        setAssessed(data.Tot_Assessment_Completed)
        setPlaced(data.Tot_Placed_Student)
        setFail(data.Tot_Failed_Student)
      })
      .catch((error)=>{
        console.error('Error fetching data:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      })})
  }
}, [authContext.userType, authContext.centre]); //


const fetchData = async () => {
  try {
    const response = await axios.get('/trainingcentre/centrewisebatches');
    const data = response.data;
    //console.log(data);
    // Extracting overall totals and center details from the response
    setOverallTotals(data.OverallTotals);
    setCenterDetails(data.CenterDetails);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
//console.log(totBatch)
useEffect(() => {
  fetchData();
  if(authContext.userType==='Superadmin'||authContext.userType==='Manager'||authContext.userType==='Accounts'){
    axios.post('/students/getPassedPlacedAssessed')
    .then(response => {
      const data = response.data;
      //console.log(data)
      setPassed(data[0].Tot_Passed_Student)
      setTotBatches(data[0].Tot_Batches)
      setTotStuds(data[0].Tot_Students)
      setFail(data[0].Tot_Failed_Student)
        setAssessed(data[0].Tot_Assessment_Completed)
        setPlaced(data[0].Tot_Placed_Student)
  })
  }
}, [authContext.user,authContext.userType]);
const[allInvoice,setAllInvoice]=useState('')
  // Fetching total purchase amount
  useEffect(()=>{
if(authContext.userType==='Accounts'){
  axios.post('/invoice/CountAll')
  .then(response => {
    const data = response.data;
    setAllInvoice(data)

})}
  },[authContext.userType])

  // Fetching all stores data

//console.log(authContext.userType)
 

  return (
    <>
      <div className={`grid grid-cols-1 col-span-12 lg:col-span-10 gap-6 md:grid-cols-3 
  ${authContext.userType === 'Accounts' ? 'lg:grid-cols-4' : 'lg:grid-cols-6'} mx-4`}>
  <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl 
  transition-shadow duration-300 w-full ">

        <div>
        <strong className="block text-md font-medium text-gray-500">
           <div className='flex items-centre justify-between'>
          
           Total Batches
          
            
           </div>
          </strong>
          <p className="mt-2 text-gray-600">
            <span className="text-4xl font-semibold text-slate-700">
            {totBatch}
            </span>
          </p>
      </div>
    </article>

    <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
   
          <div>
            <strong className="block text-md font-medium text-gray-500">
            <div className='flex items-centre justify-between'>

            {(authContext.userType!=='Accounts')
              ?"Total Students":"Total Expense"}
            </div>
            </strong>

            <p className="mt-2 text-gray-600">

              <span className="text-4xl font-semibold text-slate-700">
              
              {(authContext.userType==='Accounts')?`₹${overallTotals.Tot_expenses}`:totStuds}
              </span>

              <span className="text-xs text-gray-500"> </span>
            </p>
          </div>
        </article>
        
  <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
    
          <div>
            <strong className="block text-md font-medium text-gray-500">
            <div className='flex items-centre justify-between'>
            {(authContext.userType!=='Accounts')
              ?"Total Assessed":"Total Invoice"}
              </div>
            </strong>

            <p className="mt-2 text-gray-600">

              <span className="text-4xl font-semibold text-slate-700">
              {(authContext.userType==='Accounts')?`${allInvoice}`:assessed}
              </span>

              {/* <span className="text-xs text-gray-500"> from $404.32 </span> */}
            </p>
          </div>
        </article>
        {
  authContext.userType!=='Accounts' &&(
    <>
        <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
   
   <div>
     <strong className="block text-md font-medium text-gray-500">
     <div className='flex items-centre justify-between'>

     
       Total Pass
     </div>
     </strong>

     <p className="mt-2 text-gray-600">

       <span className="text-4xl font-semibold text-slate-700">
       
       {passed}
       </span>

       <span className="text-xs text-gray-500"> </span>
     </p>
   </div>
 </article>
     <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
   
   <div>
     <strong className="block text-md font-medium text-gray-500">
     <div className='flex items-centre justify-between'>

     
       Total Fail
     </div>
     </strong>

     <p className="mt-2 text-gray-600">

       <span className="text-4xl font-semibold text-slate-700">
       
       {fail}
       </span>

       <span className="text-xs text-gray-500"> </span>
     </p>
   </div>
 </article>
    </>
  )
 }
  <article className="flex flex-col gap-4 pt-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
     

          <div>
            <strong className="block text-md font-medium text-gray-500">
            <div className='flex items-centre justify-between'>
              {authContext.userType==='Accounts'?'Payable Amount':'Total Placed'}
           </div>
            </strong>


            <p className="mt-2 text-gray-600">

              <span className="text-4xl font-semibold text-slate-700">
              {authContext.userType==='Accounts'
                ?`₹${overallTotals.Tot_balance}`:placed}
              </span>

              {/* <span className="text-xs text-gray-500"> from 0 </span> */}
            </p>          </div>
        </article>
        <div className="sm:flex justify-around bg-white rounded-lg p-5 col-span-full flex-1 shadow-md">
          <BarChart auth={authContext}/>
          <PieChart centerDetails={centerDetails} courseDetails={courseDetails} auth={authContext}/>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
